module.exports = __webpack_public_path__ + "img/mod.aabed234.svg";